import { StyledComponent } from "@emotion/styled";
import { Box, BoxProps, Popper, PopperProps, styled } from "@mui/material";

export const PopperWithArrow: StyledComponent<PopperProps> = styled(Popper, {
  shouldForwardProp: (prop) => prop !== "arrow",
})(({ theme }) => ({
  zIndex: 1,
  "& > div": {
    position: "relative",
  },
  '&[data-popper-placement*="bottom"]': {
    "& .MuiPopper-arrow": {
      top: 0,
      left: 0,
      marginTop: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "0 1em 1em 1em",
        borderColor: `transparent transparent ${theme.palette.background.paper} transparent`,
      },
    },
  },
  '&[data-popper-placement*="top"]': {
    "& .MuiPopper-arrow": {
      bottom: 0,
      left: 0,
      marginBottom: "-0.9em",
      width: "3em",
      height: "1em",
      "&::before": {
        borderWidth: "1em 1em 0 1em",
        borderColor: `${theme.palette.background.paper} transparent transparent transparent`,
      },
    },
  },
  '&[data-popper-placement*="right"]': {
    "& .MuiPopper-arrow": {
      left: 0,
      marginLeft: "-0.9em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 1em 1em 0",
        borderColor: `transparent ${theme.palette.background.paper} transparent transparent`,
      },
    },
  },
  '&[data-popper-placement*="left"]': {
    "& .MuiPopper-arrow": {
      right: 0,
      marginRight: "-0.9em",
      height: "3em",
      width: "1em",
      "&::before": {
        borderWidth: "1em 0 1em 1em",
        borderColor: `transparent transparent transparent ${theme.palette.background.paper}`,
      },
    },
  },
  variants: [
    {
      // @ts-ignore
      props: ({ arrow }) => arrow,
      style: {
        '&[data-popper-placement*="bottom"]': {
          "& > div": {
            marginTop: 2,
          },
        },
      },
    },
    {
      // @ts-ignore
      props: ({ arrow }) => !arrow,
      style: {
        '&[data-popper-placement*="bottom"]': {
          "& > div": {
            marginTop: 0,
          },
        },
      },
    },
    {
      // @ts-ignore
      props: ({ arrow }) => arrow,
      style: {
        '&[data-popper-placement*="top"]': {
          "& > div": {
            marginBottom: 2,
          },
        },
      },
    },
    {
      // @ts-ignore
      props: ({ arrow }) => !arrow,
      style: {
        '&[data-popper-placement*="top"]': {
          "& > div": {
            marginBottom: 0,
          },
        },
      },
    },
    {
      // @ts-ignore
      props: ({ arrow }) => arrow,
      style: {
        '&[data-popper-placement*="right"]': {
          "& > div": {
            marginLeft: 2,
          },
        },
      },
    },
    {
      // @ts-ignore
      props: ({ arrow }) => !arrow,
      style: {
        '&[data-popper-placement*="right"]': {
          "& > div": {
            marginLeft: 0,
          },
        },
      },
    },
    {
      // @ts-ignore
      props: ({ arrow }) => arrow,
      style: {
        '&[data-popper-placement*="left"]': {
          "& > div": {
            marginRight: 2,
          },
        },
      },
    },
    {
      // @ts-ignore
      props: ({ arrow }) => !arrow,
      style: {
        '&[data-popper-placement*="left"]': {
          "& > div": {
            marginRight: 0,
          },
        },
      },
    },
  ],
}));

export const PopperArrow: StyledComponent<BoxProps> = styled(Box)({
  position: "absolute",
  fontSize: 7,
  width: "3em",
  height: "3em",
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: 0,
    height: 0,
    borderStyle: "solid",
  },
});
